import { useEffect, useState } from "react";
import Footer from "../../Footer"
import Navbar from "../../Navbar"
import { useLocation } from "react-router-dom";
import CentralKitchenCostingTable from "./CentralKitchenCostingTable";
import CentralKitchenActualCostingTable from "./CentralKitchenActualTable";
import axios from "axios";
import PageStatus from "../../PageStatus/PageStatus";

const CentralKitchenCosting = () => {
    const location = useLocation();
    const { state } = location;
    const reportID = state?.reportID;
    const outletName = state?.outletName;
    const token = localStorage.getItem("token") || "";
    const baseUrl = process.env.REACT_APP_BASE_URL;

    const [reports, setReports] = useState([]);
    const [dates, setDates] = useState({
        start_dat: "",
        end_date: ""
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const toNumber = (val) => parseFloat(val) || 0;

    const fetchData = async () => {
        if (!token || !reportID) return;

        setLoading(true);
        setError(null);
        try {
            const response = await axios.post(`${baseUrl}/food-and-costing-analysis-production`, {
                token,
                calculation_id: reportID
            })

            const data = response.data;
            setReports(data);
            setDates({
                start_date: data.start_date,
                end_date: data.end_date
            })
        } catch (error) {
            console.log("Central Kitchen Costing Analysis:", error);
            setError(error?.reponse?.data?.error || error?.reponse?.data?.message || "Failed to fetch costing analysis report");
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchData()
    }, [token, reportID])

    const getActualConsumptionTotal = (items = []) => {
        return items.reduce((sum, item) => {
            return sum + toNumber(item.actual_consumption_cost);
        }, 0);
    };

    const calculatePercentage = (part, total) => {
        if (!total || total === 0) return null;
        return ((Math.abs(part) / total) * 100).toFixed(2);
    };

    const actualTotal = getActualConsumptionTotal(reports.items_actual_costing);

    const actualAccuracy = calculatePercentage(
        actualTotal,
        toNumber(reports.net_sale)
    );

    const calculateCostAccuracy = (actualPercent, theoreticalPercent) => {
        if (
            actualPercent == null ||
            theoreticalPercent == null ||
            theoreticalPercent === 0
        ) return null;

        return Math.max(
            0,
            100 - Math.abs(actualPercent - theoreticalPercent)
        ).toFixed(2);
    };

    const costAccuracy = calculateCostAccuracy(
        Number(actualAccuracy),
        toNumber(reports.sales_summary?.net_cost_percent)
    );

    const formatNumber = (val) => {
        if (val === null || val === undefined) return '0';

        const parsed = parseFloat(val);
        return parsed.toString();
    };

    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />

            <div className="p-3 text-sm bg-white text-black">
                <PageStatus
                    loading={loading}
                    error={error}
                    loadingText="Loading costing report..."
                />

                {!loading && !error && (
                    <>
                        <h1 className="text-lg font-semibold mb-3 text-center">
                            Central Kitchen Costing Analysis for {outletName} <br />
                            <span className="text-base font-normal">
                                From <span className="font-semibold">{dates.start_date}</span> To <span className="font-semibold">{dates.end_date}</span>
                            </span>
                        </h1>

                        <div className="grid grid-cols-2 gap-4 px-10">
                            <CentralKitchenCostingTable
                                data={reports}
                                calculatePercentage={calculatePercentage}
                                formatNumber={formatNumber}
                            />

                            <CentralKitchenActualCostingTable
                                data={reports}
                                actualAccuracy={actualAccuracy}
                                costAccuracy={costAccuracy}
                                formatNumber={formatNumber}
                                otherCost={reports?.other_cost_food}
                            />
                        </div>
                    </>
                )}
            </div>

            <Footer />
        </div>
    )
}

export default CentralKitchenCosting